import { DefectTabs } from "../types/DefectTabs";

/**
 * Tabs are flag gated, so a panel's rendered index is not its DefectTabs
 * value. Everything else deals in ids; these are the only place the two meet.
 */

/** 0 if the tab is not currently shown. */
export const resolveTabIndex = (
    visibleTabs: DefectTabs[],
    tab: DefectTabs
): number => Math.max(visibleTabs.indexOf(tab), 0);

/** The tab at a rendered index, falling back to the first tab. */
export const resolveTabId = (
    visibleTabs: DefectTabs[],
    index: number
): DefectTabs => visibleTabs[index] ?? DefectTabs.summary;
